import React, { useId } from 'react';
import CheckboxRow from './CheckboxRow';
import StepActions from './StepActions';
import StepShell from './StepShell';

// Checkbox list of tags, submitting the selected ids with the wizard.
export default function TagsStep({
  tags = [],
  selectedTagIds = [],
  onSelectTag,
  onNext,
  onCancel,
  title = 'Tags'
}) {
  const headingId = useId();

  const toggleTag = (tagId) =>
    onSelectTag(
      selectedTagIds.includes(tagId)
        ? selectedTagIds.filter((id) => id !== tagId)
        : [...selectedTagIds, tagId]
    );

  return (
    <StepShell>
      <h3 id={headingId}>{title}</h3>
      <form
        className="resource-form"
        onSubmit={(e) => {
          e.preventDefault();
          onNext({ tagIds: selectedTagIds });
        }}
      >
        <div className="checkbox-list" role="group" aria-labelledby={headingId}>
          {tags.map((tag) => (
            <CheckboxRow
              key={tag.id}
              id={`tag-${tag.id}`}
              label={tag.name}
              checked={selectedTagIds.includes(tag.id)}
              onChange={() => toggleTag(tag.id)}
            />
          ))}
        </div>
        <StepActions
          submit
          nextLabel="Save & Continue"
          onCancel={onCancel}
          className="form-actions"
        />
      </form>
    </StepShell>
  );
}
